import * as  actionType from '../actions/types';

const initialState = {
    token: localStorage.getItem('vip_token'),
    tokenAdmin: localStorage.getItem('vip_token_admin'),
    isAuthenticated: null,
    isAuthenticatedAdmin: null,
    loading: true,
    user: '',
    forgot: '',
    changePassword: [],
    resetPassword: [],
    changePasswordLoader: false,
    resetPasswordLoader: false,
    forgotLoader: false,
    addProfileLoader: false,
    addProfileData: [],
    isConnection: false,
    gireAuth: ''
};

function authReducer(state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case actionType.USER_LOADED:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                user: payload
            };
            case actionType.USER_LOADED_ADMIN:
            return {
                ...state,
                isAuthenticatedAdmin: true,
                loading: false,
                user: payload
            };
        case actionType.REGISTER_SUCCESS:
        case actionType.LOGIN_SUCCESS:
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                loading: false
            };
        case actionType.LOGIN_SUCCESS_ADMIN:
            return {
                ...state,
                ...payload,
                isAuthenticatedAdmin: true,
                loading: false
            };
        case actionType.ACCOUNT_DELETED:
        case actionType.AUTH_ERROR:
        case actionType.LOGOUT:
            return {
                ...state,
                token: null,
                isAuthenticated: false,
                loading: false,
                user: "",
            };
        case actionType.LOGOUT_ADMIN:
            return {
                ...state,
                tokenAdmin: null,
                isAuthenticatedAdmin: false,
                loading: false,
                user: "",
            };
        case actionType.FORGOT_SUCCESS:
            return {
                ...state,
                forgot: payload,
                //isAuthenticated: false,
                loading: false
            };
        case actionType.FORGOT_LOADER:
            return {
                ...state,
                forgotLoader: payload,
            };
        case actionType.CHANGE_SUCCESS:
            return {
                ...state,
                changePassword: payload,
                loading: false
            };
        //Reset PAssword
        case actionType.RESET_SUCCESS:
            return {
                ...state,
                resetPassword: payload,
                loading: false
            };
        case actionType.RESET_LOADER:
            return {
                ...state,
                resetPasswordLoader: payload,
            };
        case actionType.CHANGE_LOADER:
            return {
                ...state,
                changePasswordLoader: payload,
            };
        // GET PROFILE DATA
        case actionType.GET_PROFILE_DATA_LOADER:
            return {
                ...state,
                addProfileLoader: payload,
            };
        case actionType.GET_PROFILE_DATA:
            return {
                ...state,
                addProfileData: payload,
            };
        // ADD UPDATE PROFILE
        case actionType.ADD_UPDATE_PROFILE_LOADER:
            return {
                ...state,
                addProfileLoader: payload,
            };
        case actionType.ADD_UPDATE_PROFILE_DATA:
            return {
                ...state,
                user: payload,
                // user:state.user.map(data=>(data._id === payload._id)&&{
                //     ...payload
                //
                // }),
            };
        case actionType.SEND_CONNECTION_REQUEST_DATA:
            return {
                ...state,
                user: {
                    ...state.user,
                    sentRequests: payload.sentRequests,
                    receivedRequests: payload.receivedRequests,
                    friends: payload.friends,
                    blockedFriends: payload.blockedFriends,
                },
            };
        case actionType.REJECT_CONNECTION_REQUEST_DATA:
            return {
                ...state,
                user: {
                    ...state.user,
                    sentRequests: payload.sentRequests,
                    receivedRequests: payload.receivedRequests,
                    friends: payload.friends,
                    blockedFriends: payload.blockedFriends,
                },
            };
        case actionType.REJECT_CONNECTION_UPDATE_NOTIFICATION_DATA:
            return {
                ...state,
                user: {
                    ...state.user,
                    notification: state.user.notification.filter(data => data._id !== payload),
                }
            };
        case actionType.ACCEPT_CONNECTION_REQUEST_DATA:
            return {
                ...state,
                user: {
                    ...state.user,
                    sentRequests: payload.sentRequests,
                    receivedRequests: payload.receivedRequests,
                    friends: payload.friends,
                    blockedFriends: payload.blockedFriends,
                },
            };
        case actionType.REMOVE_FRIEND_CONNECTION_REQUEST_DATA:
            return {
                ...state,
                user: {
                    ...state.user,
                    sentRequests: payload.sentRequests,
                    receivedRequests: payload.receivedRequests,
                    friends: payload.friends,
                    blockedFriends: payload.blockedFriends,
                },
            };


        //  Connect to Global India RealEstateGET PROFILE DATA
        case actionType.CONNECT_TO_GIRE_LOADER:
            return {
                ...state,
                isConnection: payload,
            };
        case actionType.CONNECT_TO_GIRE_SUCCESS:
            return {
                ...state,
                gireAuth: payload,
            };

        //Notification Handle
        case actionType.ADD_READ_NOTIFICATION:
            return {
                ...state,
                user: {
                    ...state.user,
                    notification: state.user.notification.map(data => ({...data, is_read: true})),
                }
            };

        default:
            return state;
    }
}

export default authReducer;
